<template>
  <div>
    <van-row :gutter="10">
      <van-col :span="nums" v-for="(item,index) in lists" :key="index">
        <div
          :class="{'form-box-tag':true,'active':currentIndex==index ? true:false}"
          @click="swap(index,item)"
        >{{item.label}}</div>
      </van-col>
    </van-row>
    <van-row :gutter="10">
      <van-col :span="nums" v-for="(item,index) in children" :key="index">
        <div
          :class="{'form-box-tag':true,'active':childIndex==index ? true:false}"
          @click="swapchild(index,item)"
        >{{item.label}}</div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Toast,
  Cell,
  CellGroup,
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  Row,
  Col,
  Tag
} from "vant";

export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag
  },

  data() {
    return {
      isactive: true,
      currentIndex: -1,
      childIndex: -1,
      data: [],
      children: [],
      district: [],
      searchValue: ""
    };
  },
  props: {
    nums: {
      type: Number,
      default: 6
    },
    lists: Array,
    select: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.data = this.lists;
  },
  watch: {
    select: function() {
      if (this.select != "") {
        var arr = this.select.split(",");

        for (var i in this.lists) {
          if (this.lists[i].value == arr[0]) {
            this.currentIndex = i;
            this.children = this.lists[i].children;
          }
        }
        for (var i in this.children) {
          if (this.children[i].value == arr[1]) {
            this.childIndex = i;
          }
        }
      }
    }
  },
  methods: {
    swap(index, item) {
      //  console.log(this.data);
      //  this.searchValue = value;
      this.currentIndex = index;
      //
      this.children = this.lists[index].children;
    },
    swapchild(index, item) {
      this.childIndex = index;
      this.district = [
        {
          name: this.lists[this.currentIndex].label,
          id: this.lists[this.currentIndex].value
        },
        {
          name: this.lists[this.currentIndex].children[this.childIndex].label,
          id: this.lists[this.currentIndex].children[this.childIndex].value
        }
      ];
      this.$emit("change", this.district);
    }
  }
};
</script>

<style scoped>
.form-box-tag {
  background-color: #f8f8f8;
  line-height: 32px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
}
.form-box-tag.active {
  background-color: #fff;
  border: #f56229 1px solid;
  color: #f56229;
}
</style>>



